import React, { Component } from 'react';
import { connect } from 'react-redux';
import { signinUser, switchModal, beelineText } from '../../actions';
import SignIn from './SignIn';
import Register1 from './Register1';
import Register2 from './Register2';
import Register3 from './Register3';
import OneMore from './LandingModal';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import TTSModal from './TTSModal';
import BeelineReaderModal from './BeelineReaderModal';
import OnboardingInitial from './OnboardingInitial';
import Onboarding1 from './Onboarding1';
import Onboarding2 from './Onboarding2';
import Onboarding3 from './Onboarding3';
import Onboarding4 from './Onboarding4';
import ContactModal from './ContactModal';
import Success from './Success';
import MissingSurvey from './MissingSurvey';

class RootModal extends Component {
  componentDidMount() {
    this.props.beelineText();
  }

  componentDidUpdate() {
    this.props.beelineText();
  }

  renderModal = () => {
    switch (this.props.currPage) {
      case 'SignIn':
        return <SignIn />;
      case 'Register1':
        return <Register1 />;
      case 'Register2':
        return <Register2 />;
      case 'Register3':
        return <Register3 />;
      case 'Success':
        return <Success />;
      case 'OneMore':
        return <OneMore />;
      case 'ResetPass':
        return <ResetPassword />;
      case 'ForgotPass':
        return <ForgotPassword />;
      case 'TTS':
        return <TTSModal />;
      case 'BeelineReader':
        return <BeelineReaderModal />;
      case 'OnboardingInitial':
        return <OnboardingInitial />;
      case 'Onboarding1':
        return <Onboarding1 />;
      case 'Onboarding2':
        return <Onboarding2 />;
      case 'Onboarding3':
        return <Onboarding3 />;
      case 'Onboarding4':
        return <Onboarding4 />;
      case 'Contact':
        return <ContactModal />;
      case 'MissingSurvey':
        return <MissingSurvey />;
      default:
        return <SignIn />;
    }
  };

  render() {
    return (
      this.props.toggle
        ? this.renderModal()
        : null
    );
  }
}

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    currPage: state.modal.currPage,
  }
);

export default connect(mapStateToProps, { signinUser, switchModal, beelineText })(RootModal);
